export default __webpack_public_path__ + "static/media/no-charts.540190bf.svg";